import { GradeModel, ScoringLevelModel } from "./lookupApiSlice";

export function lookupGrade(id: number, grades: GradeModel[]) {
	return grades?.find((g) => g.gradeId == id);
}

export function lookupGradeByName(name: string, grades: GradeModel[]) {
	return grades?.find((g) => g.name == name);
}

export function lookupLevel(scoringLevels: ScoringLevelModel[], grade?: GradeModel) {
	return scoringLevels?.find((s) => s.scoringLevelId == grade?.scoringLevelId);
}
